import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import _ from "lodash";

import "./index.css";

import BuyerPOView from "./Components/BuyerPOView";

import { getBuyerQuotes } from "../../services/api/buyerQuote";
import { getBuyerPOByBuyerPOId } from "../../services/api/buyerPO";
import { getBuyerRequirementsById } from "../../services/api/buyerReq";
import { getApprovalInstancesByDocNo } from "../../services/api/approvalInstances";
import { getProformaInvoiceByBuyerPOId } from "../../services/api/proformaInvoice";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../services/api/buyerReqItem";

import { raiseToast } from "../../services/redux/reducers/toast/toast"


const BuyerPO = () => {
    const { buyerPOId } = useParams()
    
    const [isLoading, setIsLoading] = useState(true)

    const [buyerReq, setBuyerReq] = useState({})
    const [buyerQuote, setBuyerQuote] = useState({})
    const [buyerPO, setBuyerPO] = useState([])
    const [buyerPOItems, setBuyerPOItems] = useState([])
    const [proformaInvoice, setProformaInvoice] = useState({})
    const [poSchedule, setPOSchedule] = useState([])
    const [poScheduleItems, setPOScheduleItems] = useState([])
    const [poPunch, setPOPunch] = useState([])
    const [poPunchItems, setPOPunchItems] = useState([])
    const [materialDetails, setMaterialData] = useState([])

    const [approvalInstances, setApprovalInstances] = useState([])
    
    const [pmCompanyBillAddrDetails, setPMCompanyBillAddrDetails] = useState({})
    const [buyerBillAddrDetails, setBuyerBillAddrDetails] = useState({})
    const [documentHTML, setDocumentHTML] = useState('')
    const [buyerPOPdfURL, setBuyerPOPDFURL] = useState('')

    const dispatch = useDispatch()

    useEffect(()=>{
        if (buyerPOId){
            getBuyerPO()
        }
    }, [buyerPOId])

    const getBuyerPO = async () => {
        const response = await getBuyerPOByBuyerPOId(buyerPOId)

        if(response.failure) return dispatch(raiseToast({severity:'error', summary: 'Buyer PO', detail: response.data.error, life: 3000}))
        const relatedBuyerPO = response?.data.buyerPO

        let buyerPOItems = response?.data.buyerPOItems
        let updatedPOPunch = response?.data.poPunch
        let updatedPOScheduleItems = response?.data.poScheduleItem
        let updatedPOPunchItems = response?.data.poPunchItem
        let updatedPOSchedule = response?.data.poSchedule
        let equalQuantityScheduled = true
        buyerPOItems?.map(eachBuyerPOItem => {
            let totalScheduledQty = 0
            updatedPOScheduleItems?.map(eachPOScheduleItem => {
                if (eachPOScheduleItem.buyerReqItemId === eachBuyerPOItem.buyerReqItemId) {
                    totalScheduledQty += eachPOScheduleItem.scheduledQty
                }
            })
            if (totalScheduledQty !== eachBuyerPOItem?.bPOQty) {
                equalQuantityScheduled = false
            }
        })
        let updatedBuyerPO
        if (relatedBuyerPO?.poSource === "Normal") {
            updatedBuyerPO = { ...relatedBuyerPO, isPunchDone: true, isNormalPunchDone: true }
        } else if (relatedBuyerPO?.poSource === "Via Mail") {
            updatedBuyerPO = { ...relatedBuyerPO, isNormalPunchDone: false, isPunchDone: true }
        } else {
            updatedBuyerPO = { ...relatedBuyerPO, isPunchDone: false }
        }
        
        const buyerReqItemsIds = buyerPOItems?.map(eachBuyerPOItem => eachBuyerPOItem?.buyerReqItemId)
        let materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds({buyerReqItemsIds: buyerReqItemsIds})
        if(materialDetailsRes.failure){
            dispatch(raiseToast({severity:'error', summary: 'Material Details', detail: materialDetailsRes.data.error, life: 3000}))
        }else {
            setMaterialData(materialDetailsRes?.data)
        }

        const proformaInvoiceRes = await getProformaInvoiceByBuyerPOId(buyerPOId)
        if(proformaInvoiceRes.failure){
            dispatch(raiseToast({severity:'error', summary: 'Proforma Invoice', detail: proformaInvoiceRes.data.error, life: 3000}))
        }else {
            setProformaInvoice(proformaInvoiceRes?.data)
        }

        const buyerReqRes = await getBuyerRequirementsById(updatedBuyerPO?.buyerReqId)
        if(buyerReqRes.failure){
            dispatch(raiseToast({severity:'error', summary: 'Buyer Req', detail: buyerReqRes.data.error, life: 3000}))
        }

        const approvalInstanceRes = await getApprovalInstancesByDocNo({docNo: relatedBuyerPO.docNo})
        if (approvalInstanceRes?.failure){  
            dispatch(raiseToast({severity:'error', summary: 'Approval Instance', detail: approvalInstanceRes.data.error, life: 3000}))
        }

        let buyerQuoteIds = [relatedBuyerPO?.buyerQuoteId]
        
        const buyerQuoteRes = await getBuyerQuotes({buyerQuoteIds: buyerQuoteIds})
        if (buyerQuoteRes?.failure){  
            dispatch(raiseToast({severity:'error', summary: 'Buyer Quote', detail: buyerQuoteRes.data.error, life: 3000}))
        }


        setApprovalInstances(approvalInstanceRes?.data)
        setBuyerQuote(buyerQuoteRes?.data?.data)
        setBuyerReq(buyerReqRes?.data?.buyerRequirement)
        setBuyerPO(updatedBuyerPO)
        setPOPunch(updatedPOPunch)
        setPOPunchItems(updatedPOPunchItems)
        setBuyerPOItems(buyerPOItems)
        setPOSchedule(updatedPOSchedule)
        setPOScheduleItems(updatedPOScheduleItems)
        // setShowSubmitPO(equalQuantityScheduled)

        setPMCompanyBillAddrDetails(response?.data?.pmCompanyBillAddrDetails)
        setBuyerBillAddrDetails(response?.data?.buyerBillAddrDetails)
        setDocumentHTML(response?.data?.documentHTML)
        setBuyerPOPDFURL(response?.data?.buyerPOPDFURL)

        setIsLoading(false)
    }

    return (
        <>
            <div style={{ display: "flex", flexDirection: "column",lineHeight: "1.5", height: "auto"}} className="buyer-po-doc pb-3 md:align-items-center">
                <BuyerPOView 
                    buyerPOId={buyerPOId}
                    buyerPO={buyerPO}
                    buyerPOItems={buyerPOItems}
                    poPunch={poPunch}
                    buyerReq={buyerReq}
                    buyerQuote={buyerQuote}
                    buyerBillAddrDetails={buyerBillAddrDetails}
                    materialDetails={materialDetails}
                    documentHTML={documentHTML}
                    buyerPOPdfURL={buyerPOPdfURL}
                    setBuyerPOPDFURL={setBuyerPOPDFURL}
                    getBuyerPO={getBuyerPO}
                    approvalInstances={approvalInstances}
                    setApprovalInstances={setApprovalInstances}
                    proformaInvoice={proformaInvoice}
                    setProformaInvoice={setProformaInvoice}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                />
            </div>
        </>
    )
}

export default BuyerPO;